module.exports = __webpack_public_path__ + "img/instagram.36a2d821.svg";